import {
    StyleSheet
} from "react-native";

export default StyleSheet.create({
    container: {
        position: "relative",
        overflow: "hidden"
    },
    backgroundImage: {
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 97
    },
    image:{
        width: "100%",
        height: "100%",
        zIndex: 98
    },
    linear:{
        position: "absolute",
        height: "100%",
        width: "100%",
        zIndex: 99,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    content:{
        position: "absolute",
        zIndex: 100,
        right: 0,
        left: 0
    },
    arrowContainer: {
        position: "absolute",
        zIndex: 100,
        backgroundColor: "rgba(80, 60, 20, 0.6)"
    }
});
